import { useEffect, useState } from 'react';
export default function useOptionsList(props) {
    const { options, initialNumOptions = 5 } = props;
    const [isShowAll, setIsShowAll] = useState(false);
    const [optionsToRender, setOptionsToRender] = useState(options);
    useEffect(() => {
        if (isShowAll) {
            setOptionsToRender(options);
        }
        else {
            setOptionsToRender(options.slice(0, initialNumOptions));
        }
    }, [isShowAll, options, initialNumOptions]);
    return {
        // props
        initialNumOptions,
        isShowAll,
        setIsShowAll,
        optionsToRender,
        setOptionsToRender,
    };
}
